export default __webpack_public_path__ + "static/media/meeting.32847422.png";